import React, { FC, memo } from "react";

import {
  useParams,
  useSearchParams,
  useLocation,
  useNavigate,
  useNavigation,
  NavigateOptions,
  To,
  NavLinkProps,
  NavLink,
} from "react-router-dom";

type Props = {
  to?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  state?: { prevPath: string };
  role?: string;
  Component?: FC<NavLinkProps>;
  externalLink?: boolean;
};

export const useAppParams = () => {
  return useParams();
};

export const useAppLocation = () => {
  return useLocation();
};

export const useAppSearchParams = () => {
  return useSearchParams();
};

export const useAppNavigate = () => {
  const navigateFn = useNavigate();

  const navigate = (to: To | number, options?: NavigateOptions | undefined) => {
    if (typeof to === "string") {
      const toPath = to.toString().replaceAll("//", "/");
      return navigateFn(toPath, options);
    } else if (typeof to === "number") {
      return navigateFn(to as number);
    } else {
      return navigateFn(to, options);
    }
  };

  return navigate;
};

export const useAppNavigation = useNavigation;

export const AppLink = memo(
  ({ to, children, className, onClick, state, role, Component = NavLink, externalLink }: Props) => {
    const toPath = externalLink && to ? to : to ? to.replaceAll("//", "/") : "";
    return (
      <Component
        to={toPath}
        className={className}
        onClick={onClick}
        state={state}
        role={role}
        relative={"path"}
      >
        {children}
      </Component>
    );
  },
);
